<template>
  <div class="job-list-page box" style="margin-bottom:0">
    <div class="box-header">
      <h3 class="box-title"><i class="fa fa-th-large"></i> 自定义表单列表</h3>
    </div>
    <div class="box-body">
      <!-- 搜索工具栏-->
      <el-row class="margin-bottom-15" :gutter="10">
        <el-col :span="18">
          <el-button type="primary" size="small" @click="toAdd()" plain><i class="fa fa-plus"></i> 创建表单</el-button>
        </el-col>
        <el-col :span="6" class="text-align-reverse">
          <el-input placeholder="请输入项目名称"  size="small" class="input-with-select">
            <el-button slot="append" @click="doSearch()"><i class="fa fa-search"></i> 搜索</el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <div class="no-data" v-if="list.length === 0">暂无数据！</div>
      <el-row v-else :gutter="40">
        <el-col :span="6" v-for="o in list" :key="o">
          <div class="phone-card ">
            <div class="fm-warp">
              <div class="title">{{o.name}}</div>
              <div v-if="o.control != null">
                <div v-for="x in o.control.list" :key="x" >
                  <div class="fm-item">
                    <label class="label">{{x.name}}：</label>
                    <div class="compent">
                      <el-input v-if="x.type == 'input'"></el-input>
                      <el-input type="textarea" v-if="x.type == 'textarea'"></el-input>
                      <el-select v-else-if="x.type == 'select'" placeholder="请选择" style="width: 100%">
                        <el-option
                          v-for="item in x.options.options"
                          :key="item.value"
                          :label="item.value"
                          :value="item.value">
                        </el-option>
                      </el-select>
                      <el-radio-group v-else-if="x.type == 'radio'" style="line-height: 32px">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="0">女</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix operation" style="padding: 14px;">
              <div class=" clearfix pull-right">
                <el-button @click.prevent="toEditForm(o.id)" size="mini" plain round type="primary">修改</el-button>
                <el-button @click.prevent="doRemove(o.id)" size="mini" plain round type="danger">删除</el-button>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 分页-->
      <page-bar v-model="page" @change="fetchData"></page-bar>
    </div>

    <el-dialog title="自定义表单" :visible.sync="addRecharge" @close="addRecharge = false" width="25%">
      <el-form :model="form" ref="form" label-width="80px">
        <el-form-item label="名称" prop="title">
          <el-input v-model="form.name" placeholder="请输入自定义表单名称"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="title">
          <el-input type="textarea" v-model="form.intro" placeholder="请输入自定义表单描述"></el-input>
        </el-form-item>
      </el-form>
      <div class="text-align-center">
        <el-button @click="addRecharge = false" size="small" round><i class="fa fa-close"></i> 取消 </el-button>
        <el-button type="primary" @click="saveBrand()" size="small" round><i class="fa fa-save"></i> 保存 </el-button>
      </div>
    </el-dialog>

    <el-dialog
      v-if="addDialog"
      title="设计表单"
      :destroy-on-close="true"
      :append-to-body="true"
      :visible.sync="addDialog"
      :modal-append-to-body="true"
      width="880px">
      <form-save @done="saveFinish"></form-save>
    </el-dialog>
  </div>
</template>

<script>
  import {fetchData,save,get,remove} from "@api/evaluation/form";
  import pageBar from "@components/PageBar";
  import {handleConfirm} from '@utils/confirm'
  import { deepClone } from '@/utils/index'


  export default {
    name: 'form-List',
    data: function () {
      return {
        addDrawer: false,
        drawerVisible: false,
        isEdit: false,
        page: {
          pageNo: 1,
          pageSize: 20,
          param: {}
        },
        list: [],
        info: {},
        form:{},
        addRecharge:false,
      }
    },
    created() {
      this.fetchData()
    },
    components: {
      pageBar
    },
    methods: {
      fetchData: function () {
        let userId = this.$store.state.user.info.id

        fetchData(userId).then(resp => {
          this.list = resp.data.result
          this.list.map(x =>{
            if (x.control != null)
            x.control = JSON.parse(x.control)
          })
        })
      },
      doRemove(val) {
        handleConfirm('此操作将永久删除, 是否继续?').then(() => {
          remove(val).then(resp => {
            this.$message.success(resp.data.message)
            this.fetchData()
          })
        })
      },
      toAdd(){
        this.addRecharge = true
      },
      toEdit(val){
        this.addRecharge = true
        get(val).then(resp => {
          this.form = resp.data.result
        })
      },
      saveBrand(){
        this.$refs['form'].validate((valid) => {
          if (valid) {
            let data = deepClone(this.form)
            data.userId = this.$store.state.user.info.id
            save(data).then(resp => {
              this.$message.success(resp.data.message)
              this.addRecharge = false
              this.fetchData()
            })
          }
        });
      },
      toEditForm(val){
        this.$router.push({path: '/evaluation/form/save', query: {id: val}})
      }
    }
  }
</script>

<style type="text/scss" lang="scss">
  .phone-card{
    background: url('~@images/phone_bg.png') 0 0 no-repeat;
    background-size: contain;
    width: 260px;
    height: 528px;
    position: relative;
    .fm-warp{
      box-sizing: border-box;
      width: 232px;
      margin: 0 auto;
      padding: 0 20px;
      padding-top: 48px;
      height: 436px;
      .title{
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 20px;
      }
      .fm-item{
        display: flex;
        margin-bottom: 10px;

      }
      .label{
        width: 100px;
        line-height: 24px;
        font-size: 12px;
      }
      .compent{
        width: 100%;
      }
      .el-input__inner {
        height: 24px;
        line-height: 24px;
      }
      .el-input__inner {
        height: 24px;
        line-height: 24px;
      }
      .el-input__icon {
        line-height: 24px;
      }
    }
    .operation{
      position: absolute;
      bottom: 20px;
      right: 56px;
    }
  }

    .no-data {
      text-align: center;
      padding: 50px 0;
      &::before {
        content: ' ';
        display: block;
        min-height: 180px;
        background: url("~@images/nodata1.png") center 0 no-repeat;
        background-size: contain;
      }
  }

</style>
